import React, { useEffect, useState } from 'react';
import { arrayMove } from '@dnd-kit/sortable';
import { commonMessage } from '@locales/intl';
import { showErrorMessage, showSucsessMessage } from '@services/notifyService';

import useFetch from './useFetch';
import useNotification from './useNotification';
import useTranslate from './useTranslate';

const sortColumn = {
    key: 'sort',
    width: 30,
};

function useDragDropV2({ data = [], apiConfig, setTableLoading, indexField, onUpdated = () => {}, onError }) {
    const translate = useTranslate();
    const [sortedData, setSortedData] = useState(
        (data.length > 0 && data.sort((a, b) => a?.[indexField] - b?.[indexField])) || [],
    );
    const { execute: executeOrdering, loading: loadingOrdering } = useFetch(apiConfig);
    const notification = useNotification();
    const onDragEnd = ({ id: dragId }, { id: hoverId }) => {
        if (dragId == hoverId) return;
        const dragIndex = sortedData.findIndex((item) => item.id == dragId);
        const hoverIndex = sortedData.findIndex((item) => item.id == hoverId);
        const movedData = moveArrayElement(sortedData, dragIndex, hoverIndex);
        setSortedData(movedData);
    };
    const validateNoteOrder = (notes) => {
        for (let i = 0; i < notes.length - 1; i++) {
            const currentNote = notes[i];
            const nextNote = notes[i + 1];

            if (currentNote.endTime > nextNote.startTime) {
                return false;
            }
        }
        return true;
    };
    const onDragEndDnd = ({ active, over }) => {
        if (!sortedData || sortedData?.length <= 1) return;
        if (active?.id !== over?.id) {
            const isNew = active.id?.startsWith?.('temp-');
            setSortedData((prevState) => {
                const activeIndex = prevState.findIndex((record) => record.id === active?.id);
                const overIndex = prevState.findIndex((record) => record.id === over?.id);
                const returnArray = arrayMove(prevState, activeIndex, overIndex);

                const isValid = validateNoteOrder(returnArray);
                if (isValid) {
                    handleUpdate(returnArray, isNew);
                } else {
                    showErrorMessage(translate.formatMessage(commonMessage.invalidOrder), translate);
                    return prevState;
                }

                return returnArray;
            });
        }
    };
    const handleUpdate = (data = [], isNew) => {
        let dataUpdate = [];
        const sortList = data.length > 0 ? data : sortedData;
        sortList.map((item, index) => {
            dataUpdate.push({
                id: item.id,
                [indexField]: index,
            });
        });
        if (!isNew)
            executeOrdering({
                data: dataUpdate,
                onCompleted: () => {
                    showSucsessMessage(translate.formatMessage(commonMessage.success), translate);
                    onUpdated();
                },
                onError: (err) => {
                    if (onError) onError(err);
                    else {
                        showErrorMessage(translate.formatMessage(commonMessage.error), translate);
                    }
                },
            });
    };

    useEffect(() => {
        if (data && data.length > 0) {
            setSortedData(data);
        } else {
            setSortedData((prev) => (prev.length === 0 ? prev : []));
        }
    }, [data]);

    return { sortedData, onDragEnd, sortColumn, handleUpdate, onDragEndDnd, loadingOrdering };
}

const moveArrayElement = (arr = [], from, to) => {
    if (!Array.isArray(arr)) throw new Error('The first argument must be an array!');

    const copy = [...arr];
    const [movedItem] = copy.splice(from, 1);
    copy.splice(to, 0, movedItem);

    return copy;
};


export default useDragDropV2;
